import React from "react";
import AuthTwoColumnedPage from "../components/AuthTwoColumnedPage";
import LoginWidget from "../components/LoginWidget";

export default function LoginPage() {
  return (
    <AuthTwoColumnedPage
      title={
        "Education is a passport to step the world and a key to unlock doors."
      }
      caption={""}
      boxTitle={"Sign in"}
      boxCaption={"Hello there, sign in to continue"}
      videoUrl={"https://player.vimeo.com/video/448508644?autoplay=1&muted=1"}
    >
      <LoginWidget />
    </AuthTwoColumnedPage>
  );
}
